<template>

  <div
    class="row"
  >
    <div
      class="col col-12"
    >
      <template
        v-if="gallery && gallery.id"
      >
        <h3> {{gallery.title}}</h3>
        <!-- vypis obrazku -->
        <template
          v-if="gallery.images && gallery.images.length > 0"
        >

          <!-- prepinani zobrazeni -->
          <div
            class="text-end"
            @click.prevent="gallery.completeDisplay = !gallery.completeDisplay;"
          >
            <template
              v-if="gallery.completeDisplay"
            >
              <i class="bi bi-list-task"/>
            </template>
            <template
                v-else
            >
              <i class="bi bi-grid-3x3-gap-fill"/>
            </template>
            [prepnout zobrazeni]

          </div>

          <!-- vypis -->
          <template
            v-if="gallery.completeDisplay"
          >
            <div
                class="container "
            >
              <draggable
                  :list="gallery.images"
                  itemKey="obrazek_id"
                  handle=".move-image"
                  ghost-class="ghost-move-image"
                  class="row"
                  @change="onDragAfter"
              >
                <template #item="{ index, element }">
                  <div class="row mb-2">
                    <div
                        class="col col-3"
                    >
                      <div class="ratio ratio-1x1 position-relative border rounded shadow-sm bg-light overflow-hidden">

                        <!-- Tlačítko v pravém horním rohu -->
                        <div
                            v-if="false"
                            class="position-absolute top-0 end-0 p-1" style="z-index: 10;">
                          <button
                              type="button"
                              class="btn btn-primary btn-sm move-image"
                          >
                            <i class="bi bi-arrows-move"/>
                          </button>
                          <button
                              @click.prevent="removeImageFromGallery(index, element)"
                              type="button" class="btn btn-primary btn-sm ms-1">
                            <i class="bi bi-trash-fill"/>
                          </button>
                        </div>

                        <!-- Hlavní obsah vycentrovaný uprostřed -->
                        <div class="d-flex align-items-center justify-content-center">
                          <image-component
                              :key="element.image.id"
                              :image-id="element.image.id"
                              :is_preview_only="true"
                              thumb_class="gallery-image-thumb-wrap"
                          />
                        </div>
                      </div>
                    </div>

                    <div
                        class="col col-9 d-flex align-items-center justify-content-start position-relative"
                    >
                      <div class="-border border-primary w-100">
                        <simple-image-edit
                          :data-input="element"
                          :key="element.image.id"
                        />
                      </div>

                      <div class="position-absolute top-0 end-0 p-1" style="z-index: 10;">
                        <button
                            type="button"
                            class="btn btn-primary btn-sm move-image"
                        >
                          <i class="bi bi-arrows-move"/>
                        </button>
                        <button
                            @click.prevent="removeImageFromGallery(index, element)"
                            type="button" class="btn btn-primary btn-sm ms-1">
                          <i class="bi bi-trash-fill"/>
                        </button>
                      </div>
                    </div>
                  </div>



                </template>
              </draggable>

            </div>
          </template>
          <template
            v-else
          >
            [miniatury]
            <div
              class="container "
            >
              <draggable
                  :list="gallery.images"
                  itemKey="obrazek_id"
                  handle=".move-image"
                  ghost-class="ghost-move-image"
                  class="--image-wrap row row-cols-2 row-cols-sm-2 row-cols-md-3 row-cols-lg-6 row-cols-xxl-8 gap-0"
                  @change="onDragAfter"
              >
                <template #item="{ index, element }">
                  <div
                      class="col bg-warning p-2 ---position-relative"
                  >
                    <div class="ratio ratio-1x1 position-relative border rounded shadow-sm bg-light  overflow-hidden">

                      <!-- Tlačítko v pravém horním rohu -->
                      <div class="position-absolute top-0 end-0 p-1" style="z-index: 10;">
                        <button
                            type="button"
                            class="btn btn-primary btn-sm move-image"
                        >
                         <i class="bi bi-arrows-move"/>
                        </button>
                        <button
                            @click.prevent="removeImageFromGallery(index, element)"
                            type="button" class="btn btn-primary btn-sm ms-1">
                          <i class="bi bi-trash-fill"/>
                        </button>
                      </div>

                      <!-- Hlavní obsah vycentrovaný uprostřed -->
                      <div class="d-flex align-items-center justify-content-center">
                        <image-component
                            :image-id="element.image.id"
                            :is_preview_only="true"
                            thumb_class="gallery-image-thumb-wrap"
                        />
                      </div>

                    </div>
                  </div>
                </template>
              </draggable>

            </div>

          </template>

          <pre>count images: {{gallery.images.length}}</pre>

        </template>
        <template
          v-else
        >
          <div
              class="alert alert-danger text-center"
          >
            zadne obrazky
          </div>
        </template>




        <!-- pridani obrazku -->
        <div
            class="row"
        >
          <div
              class="col col-12"
          >
            <div
              class="btn-group w-100 mb-2"
            >
              <template
                v-for="(button, b) in upload.types"
              >
                <button
                    v-if="button.enabled"
                    @click.prevent="handleUploadType(b);"
                    type="button"
                    :class="'btn btn-outline-primary' + (upload.uploadType == b? ' active':'')"
                >
                  <i
                      v-if="button.ico"
                    :class="button.ico.class + ' me-1'"
                  />
                  {{ $t(button.title) }}
                </button>
              </template>
            </div>
          </div>
        </div>
        <div
          class="row"
        >
          <template
            v-if="upload.uploadType == 'device'"
          >
            <div
              class="col col-12 py-2"
            >
              <div
                class="input-group"
              >
                <input
                    type="file"
                    ref="files_gallery_upload"
                    accept="image/*"
                    placeholder="vyber obrazky"
                    multiple
                    @change="imagePreupload($event.target.files)"
                    class="form-control"
                >

                <button
                    @click.prevent="imagesUpload()"
                    ref="btnSubmit"
                    disabled
                    class="btn btn-outline-secondary"
                >
                <span v-if="upload.types.device.isValidation === true">
                  <i class="bi-hourglass"></i> {{$t('gallery.form.upload.btn_checking')}}
                </span>
                  <span v-else>
                  <i class="bi-plus-circle"></i> {{$t('gallery.form.upload.btn_title')}}
                </span>
                </button>
              </div>
              <div
                v-if="upload.types.device.error"
                class="text-danger p-2"
              >
                {{upload.types.device.error }}
              </div>
            </div>

          </template>
          <template
              v-else-if="upload.uploadType == 'server'"
          >
            <div
                class="col col-12"
            >
              [todo server upload]
            </div>
          </template>
          <template
              v-else-if="upload.uploadType == 'browser'"
          >
            <div
                class="col col-12"
            >
              <div
                v-if="false"
                class="d-flex justify-content-center align-content-center w-100 py-3"
              >
                <div
                    @click.prevent="openImageBrowser();"
                    class="btn btn-lg btn-primary"
                >
                  Otevrit prohlizec obrazku
                </div>
              </div>

            </div>
            <!-- upload.types.browser.modal -->
            <display-debug class="bg-white">
              <template #debugView>upload.types.browser  {{upload.types.browser}}</template>
            </display-debug>
            <template
              v-if="upload.types.browser.openModal"
            >
              <!--&&  v-if="false" -->
              <modal-window

                  :title="upload.types.browser.modal.title"
                  :config="upload.types.browser.modal.config"
              >
                <template #modal-content-slot>
                  <component
                      v-bind:is="'ContentIncludeView'"
                      :router="upload.types.browser.modal.router"
                      :return-data="devModal"
                      :form-prefill="upload.types.browser.modal.prefill"
                      :config="upload.types.browser.modal.config"
                      @return-values="handleBrowserResponse"
                  ></component>
                </template>
              </modal-window>

            </template>
          </template>
        </div>

      </template>
      <template
        v-else
      >
        Nejdriv vyberte/ vytvorte galerie
      </template>
    </div>
  </div>



  <div
      class="row"
  >
    <template
      v-if="gallery.isCreate === true"
    >
      <div
        class="col col-12 text-end"
      >
        <a
          href="#"
          @click.prevent="gallery.isCreate=false"
        >
          vybrat galerii
        </a>
      </div>
      <div
        class="col"
      >
        <input
          v-model="gallery.createNew.title"
          class="form-control"
          placeholder="Nazev nove galerie"
        >
      </div>
      <div
          class="col col-auto"
      >
        <button
          @click.prevent="createGallery()"
          class="btn btn-primary"
        >
          Vytvorit novou galerie
        </button>
      </div>

      <div
        v-if="gallery.createNew.error"
        class="col col-12 mt-1 text-danger"
      >
        <i class="bi-building-exclamation me-1"/>
        {{gallery.createNew.error}}
      </div>


    </template>
    <template
        v-else
    >
      <div
          class="col"
      >

        <multiselect
            v-model="gallery.selected"
            @select="onGallerySelect"
            :options="galleries.option"
            label="title"
            track-by="id"
            :searchable="true"
            :hideSelected="false"
            placeholder="Vyberte galerii"
            :custom-label="formatGalleryTitle"
        >
          <!--

           @search-change="searchGallery"
            :placeholder="this.getText('image_component.placeholder_browser')"

            @open="galerieBrowser"

           -->
          <template v-slot:singleLabel="{ option }">
            <div style="display: inline-block; margin-left: 1rem;">
              <span v-if="option.title" class="fw-light"><i class="bi bi-images"></i> {{ option.title }}</span><br>
            </div>
          </template>

          <template v-slot:option="{ option, search }" >
            <div class="multiselect_custom gallery">
              <div class="block-desc">
                <strong v-if="option.title" >{{ option.title }}</strong><br>
                <span v-if="option.pocet" >{{ option.pocet }} obrazku</span><br>
                <span v-if="option.autor_title" >autor: {{ option.autor_title }}</span><br>
              </div>
            </div>
          </template>

          <template v-slot:noResult>
            <div class="multiselect--no-results">{{this.getText('image_component.multiselect.no_result')}}</div>
          </template>

          <template v-slot:noOptions>
            <div class="multiselect--no-results">{{this.getText('image_component.multiselect.no_result')}}</div>
          </template>
        </multiselect>
      </div>
      <div
          class="col col-auto"
      >
        <button
            @click.prevent="gallery.isCreate =true;"
            class="btn btn-outline-secondary"
        >
          <i class="bi bi-plus me-1"/>
          Pridat galerie

        </button>
      </div>
    </template>




  </div>





<!--

  <display-debug class="bg-white">
    <template #debugView>gallery.selected  {{gallery.selected}}</template>
  </display-debug>


  <display-debug class="bg-white">
    <template #debugView>modelValue  {{modelValue}}</template>
  </display-debug>
  <display-debug class="bg-white">
    <template #debugView>galleries  {{galleries}}</template>
  </display-debug>
-->
</template>

<script>
import multiselect  from 'vue-multiselect'
//import "vue-multiselect/dist/vue-multiselect.css"
import ImageComponent from "@/components/general/Image";
import texts from "@/components/config/texts"
import axios from "axios";
import draggable from "vuedraggable";
import ModalWindow from "@/components/content/ModalWindow";
import SimpleImageEdit from "@/components/general/SimpleImageEdit.vue";
import ContentIncludeView from "@/views/ContentIncludeView.vue";
//import ImageBrowserModule from "@/modules/ImageBrowserModule2.vue";


export default {
  name: "GalerieComponent",
  props: {
    "modelValue": [String, Number],
    "gallery_id": [String, Number],
    "image_typ_id": [String, Number],
    "is_gallery_browser": [Boolean],
    "is_image_upload": [Boolean],
    "is_image_upload_from_server": [Boolean],
    "is_image_preview": [Boolean],
    "is_image_browser": [Boolean],
    "is_full_view": [Boolean],
    "is_creating": [Boolean],
    "lang_code": [String],
  },
  components: {
    multiselect,
    ImageComponent,
    ModalWindow,
    ContentIncludeView,
    texts,
    draggable,
    SimpleImageEdit,
    //ImageBrowserModule
  },
  emits: [
    'update:modelValue',
  ],
  data() {
    return {
      isUploadChecking: null,
      gallery: {
        selected: null,
        isCreate: false,
        completeDisplay: false,
        id: null,
        title: null,
        images: [],
        createNew: {
          title: null,
          error: null,
          is_success: null,
        }

      },
      galleries: {
        option: [],
      },
      upload: {
        deviceUpload: true,
        uploadType: null,
        types: {
          device: {
            enabled: true,
            title: "image.server.device.title",
            ico: {
              class: "bi bi-upload"
            },
            isValidation: null,
            error: null,
            success: null,
            uploadFiles: null,
            isLoading: null,
          },
          server: {
            enabled: false,
            ico: {
              class: "bi bi-hdd"
            },
            title: "image.server.upload.title"
          },
          browser: {
            enabled: true,
            title: "image.server.browser.title",
            ico: {
              class: "bi bi-images"
            },
            openModal: false,
            modal: {
              title: "prohlizec obrazku v1",
              router: {
                modul: 'image', //this.getApiConfig('restaurace.modules.section')
                action: 'image-browser',
                id: 3
              },
              config: {
                "display": true,
                "is_header": true,
                "is_close_btn": true,
                "is_footer": true
              },
              data: {
                save: false,
                submit: false,
              },
              prefill: {
                general: {
                  inputs: {
                    image_type_id: {
                      readonly: true,
                      value: 1
                    },

                  }
                },
              },
            },
            searchPhrase: null,
            selectedImagesId: []
          }
        }
      },
      timers: {

      },
      browserResponse: null,
      devModal: {},

    }
  },
  mounted() {
    console.log('dev gallery mounterd', this.modelValue);
    this.$nextTick(() => {
      console.log('dev gallery mounterd TICK', this.modelValue);
      if(
          this.modelValue
      ){
        this.gallery.id = this.modelValue;
        this.openGallery(this.gallery.id);
      }
    });

    this.loadGalleries();
  },
  created() {

  },
  computed: {

  },

  methods: {
    handleBrowserResponse(payload) {
      this.browserResponse = payload;
      //console.log('dev GALLERY handleBrowserResponse EMIT RECIEVE', payload)
    },
    openImageBrowser() {
      //console.log('dev openImageBrowser', this.upload.types.browser.modal)
      this.upload.types.browser.selectedImagesId = [];
      this.upload.types.browser.openModal = true;
      this.upload.types.browser.modal.config.display = true;

    },
    onDragAfter(){
      //console.log('dev onDragAfter')
      const iterationStep = 10;
      let p = 100;
      for (const image of this.gallery.images){
        image.poradi = p;
        p = p + iterationStep
      }

      this.updateGallery();
    },
    removeImageFromGallery(index, image){
      if (confirm("opravdu chcete vymazat obrazek z galerie") == true) {
        this.gallery.images.splice(index, 1);
        this.updateGallery();
      }
    },


    updateGallery(){
      //console.log('dev updateGallery', this.gallery)

      axios.defaults.baseURL = this.getBaseRoot();
      //let apiPath = this.cfg.api.gallery.save_service.path
      let apiPath = this.getApiConfig('gallery.save_service.path');
      let formData = new FormData();
      formData.append('galerie_id', this.gallery.id );
      formData.append('images',  JSON.stringify(this.gallery.images));
      axios({
        url: apiPath,
        data: formData,
        method: this.getApiConfig('gallery.save_service.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {

        this.gallery.images = res.data.response.images;
        //console.log("dev image browser data", res.data.response)
        //this.galerie.is_changed = false;
      })
      .catch((err) => {
        //this.browser_image_list = []
        console.log("DEV tags catch", err);
      })
      .finally(() => {
        //console.log("DEV tags finally");
      })

    },

    openGallery(id){
      this.loadGalleryImages(id);
    },
    onGallerySelect(gallery){
      this.gallery.id = gallery.id;
      this.gallery.title = gallery.title;
      this.loadGalleryImages(this.gallery.id);
    },

    searchGallery(query) {
      this.loadGalleries(query);
    },

    createGallery() {
      this.gallery.createNew.error = 'testovaci chyba';
      //console.log('dev createGallery', this.gallery.createNew)
      const dev = {
        id: 666,
        title: this.gallery.createNew.title,
        images: [],
        "autor_title": "Super admin",
        "is_display": true,
        "pocet": 0,
      }

      this.gallery.isCreate = false;

      this.galleries.option.unshift(dev)
      this.gallery.selected = dev;

      this.gallery.createNew.title = null;

    },
    loadGalleryImages(id){
      this.gallery.images = [];
      axios.defaults.baseURL = this.getBaseRoot();
      //let apiPath = this.cfg.api.gallery.images_service.path + "?" + this.cfg.api.gallery.images_service.input.query + "=" + id
      let apiPath = this.getApiConfig('gallery.images_service.path') + "?" + this.getApiConfig('gallery.images_service.input.query') + "=" + id

      axios({
        url: apiPath,
        method: this.getApiConfig('gallery.images_service.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        //console.log('dev loadGalerieImages', id, res.data.response)

        if(
            !this.gallery.selected
        ){
          this.gallery.selected = {
            id: res.data.response.gallery.id,
            title: res.data.response.gallery.title,
            //images: res.data.response.list, // nevim
          };
        }
        this.gallery.id = res.data.response.gallery.id;
        this.gallery.title = res.data.response.gallery.title;
        this.gallery.images = res.data.response.list;
      })
      .catch((err) => {
        this.gallery.images = []
      })
      .finally(() => {
        //console.log("DEV tags finally");
      })
    },
    loadGalleries(query = null){
      axios.defaults.baseURL = this.getBaseRoot();
      let apiPath = this.getApiConfig('gallery.browse_service.path');// this.cfg.api.gallery.browse_service.path
      apiPath += "?lang_code=" + this.lang_code;

      if(query) apiPath += "&" + this.getApiConfig('gallery.browse_service.input.query') + "=" + query
      axios({
        url: apiPath,
        method: this.getApiConfig('gallery.browse_service.method'),
        withCredentials: true,
        headers: this.getRequestHeader(),
      }).then((res) => {
        this.galleries.option = res.data.response.list.data;
      }).catch((err) => {
        this.galleries.option = []
        //console.log("DEV tags catch", err);
      })
      console.log('dev loadGalleries',)
    },
    formatGalleryTitle ({ id, title }) {
      return `[formatGalleryTitle] ${title}  ${id}`;
    },

    async imagesUpload(){
      if(
          this.upload.types.device.uploadFiles
          && this.upload.types.device.uploadFiles.length > 0
      ) {
        for (const image of this.upload.types.device.uploadFiles ) {
          //console.log('dev imagesUpload image', image)
          this.upload.types.device.isLoading = true;

          let formData = new FormData();
          formData.append('image_file', image );
          formData.append('image_type', this.image_typ_id);
          axios.defaults.baseURL = this.getBaseRoot();
          await axios.post(
              this.getApiConfig('image.upload_service.path'), //this.cfg.api.image.upload_service.path,
              formData,
              {
                headers: this.getRequestHeaderUpload()
              }
          ).then((res) => {

            if(typeof res.data.err == 'undefined') {

              this.gallery.images.push(
                  {
                    //"obrazek_id": res.data.response.response.id,
                    id: null,
                    item_order: 999,
                    image: {
                      id: res.data.response.response.id,
                      title: null,
                      copyright_title: null,
                      tags: [],
                    },
                  }
              )
            }
          }).catch((err) =>{
            console.error('galerie:imagesUpload', err)
          }).finally(() => {
            this.upload.types.device.isLoading = false;
            this.updateGallery();
          })


        }
      }
    },

    async imagePreupload(fileList) {
      //const maxUploadCount = 30;
      const maxUploadCount = this.getApiConfig('gallery.create_service.upload_max_files');

      if(
          fileList.length <= maxUploadCount
      ) {
        let errArr = [];
        //this.upload.types.device.error = []
        this.upload.types.device.isLoading = false;
        this.upload.types.device.uploadFiles = fileList;


        for (let i = 0; i < fileList.length; i++) {
          let formData = new FormData();
          formData.append('image_file', fileList[i] );
          formData.append('image_type', this.image_typ_id);
          formData.append('image_validate', 1 );

          axios.defaults.baseURL = this.getBaseRoot();
          await axios.post(
              this.getApiConfig('image.upload_service.path'), //this.cfg.api.image.upload_service.path,
              formData,
              {
                headers: this.getRequestHeaderUpload()
              }
          ).then((res) => {
            if(typeof res.data.err == 'object') {
              errArr.push(fileList[i].name +": " + res.data.err.message);
            }
          }).catch((err) =>{
            errArr.push(fileList[i].name +": asi se rozbilo API")
          }).finally(() => {
            this.upload.types.device.isLoading = false;
          })
        }

        if (errArr && errArr.length > 0) {
          this.$refs['btnSubmit'].disabled = true
          this.upload.types.device.isValidation = false;
          this.upload.types.device.error = errArr.join(", ");

        }else{
          this.$refs['btnSubmit'].disabled = false
          this.upload.types.device.isValidation = true;
        }

      }else{
        this.upload.types.device.error = this.$t('image.component.warning.upload_max_files', {filesCount: fileList.length, max: maxUploadCount});
      }
     },
    handleUploadType(type){
      console.log('dev handleUploadType', type)
      this.upload.uploadType = type;
      if(
          type == 'browser'
      ){
        console.log('dev handleUploadType BROWSER', type)
        this.openImageBrowser();
        //tood otevreni
      }

    }
  },
  watch: {
    "gallery.selected": function (newVal, oldVal) {
      if(
          newVal
          && newVal.id
          && newVal != oldVal
      ) {
        this.$emit('update:modelValue', newVal.id )
      }
    },

    "browserResponse": {
      handler(newVal, oldVal) {
        if(
            newVal
            && newVal.length > 0
        ){
          for (const imageId in newVal){
            const imageData = {
              image: {
                "id": newVal,
                "title": null,
                "copyright_title": null,
                "tags": []
              },
              item_order: null,
            }
            console.log("DEV watch browserResponse ADD", newVal, imageData)
            this.gallery.images.push(imageData)
            this.updateGallery();
          }
        }

        this.upload.types.browser.openModal = false;
        console.log("DEV watch browserResponse", newVal, oldVal)
      },
      deep: true,
      immediate: true
    },


//upload.types.browser.modal.data
  }
};
</script>
<style lang="scss">
  .gallery-image-item-wrap {
    max-width: 100%;
    max-height: 100%;
    overflow: hidden;

    > .image-wrap {
      width: 100%;
      height: 100%;

      .gallery-image-thumb-wrap {
        width: 100%;
        height: 100%;
        object-fit: contain !important;


      }
    }
  }



  x.gallery-image-item-wrap {
    width: 95%;
    height: 95%;
    border: 3xp blue solid !important;
    background: #41b883;
    text-align: center;
    vertical-align: middle;

  }


  img.gallery-image-thumb-wrap {
    opacity: .8;
    max-width: 100% !important;
    max-height: 100% !important;
    object-fit: cover !important;


  }
</style>